/**
 * axios跨域写法太麻烦，封装一个简单ajax
 * 普通参数使用params
 * json数据使用jsonData
 * 二进制数据使用rawData
 */

import Vue from 'vue';
import Session from '@/util/session';
import { getBaseUrl } from '@/util/env';

const urlRegexp = /(http|ftp|https):\/\//;

function type(x) {
    return typeof x;
}

function serialize(params, obj, traditional, scope) {
    var array = type(obj) === 'array';
    for (var key in obj) {
        var value = obj[key];

        if (scope) key = traditional ? scope : scope + '[' + (array ? '' : key) + ']'
        // handle data in serializeArray() format
        if (!scope && array) params.add(value.name, value.value)
        // recurse into nested objects
        else if (traditional ? (type(value) === 'array') : (type(value) === 'object'))
            serialize(params, value, traditional, key)
        else params.add(key, value)
    }
}

function param(obj, traditional) {
    var params = []
    params.add = function (k, v) { this.push(escape(k) + '=' + encodeURIComponent(v)) }
    serialize(params, obj, traditional)
    return params.join('&').replace('%20', '+')
}

function callback(xhr, resolve, reject, opt) {
    if (xhr.readyState == 4) {
        if (!opt || !opt.crossDomain) {
            try {
                // save auth header
                var auth = xhr.getResponseHeader('Authorization');
                if (auth) {
                    Session.set({
                        token: auth,
                        expire: 18000,
                        timestamp: new Date().getTime()
                    });
                }
            } catch (e) {
                console.error(e);
            }
        }

        if (xhr.status == 200) {
            if (opt.responseType == 'blob') {
                var data = (xhr.mozResponseArrayBuffer || xhr.mozResponse ||
                    xhr.responseArrayBuffer || xhr.response);
                resolve && resolve(data);
            } else {
                resolve && resolve(JSON.parse(xhr.responseText));
            }
        } else {
            reject && reject(xhr.responseText);
        }
    }
}

function request(opt, resolve, reject) {
    var xhr = new XMLHttpRequest();
    var sendData = opt.data ? param(opt.data) : null;
    var url = opt.url, scopeCompany = Session.getScopeCompany();
    // 集团版，指定子账套
    if (scopeCompany) {
        url = url + (url.indexOf('?') > 0 ? "&" : "?") + 'scopeCompany=' + scopeCompany;
    }
    if (opt.type.toUpperCase() == "GET") {
        xhr.open(opt.type, url + (sendData ? (url.indexOf('?') > 0 ? "&" : "?") + sendData : ''), opt.async);
        sendData = null;
    } else {
        xhr.open(opt.type, url, opt.async);
        if (opt.jsonData) {
            xhr.setRequestHeader("Content-type", "application/json;charset=UTF-8");
            if (typeof opt.jsonData === 'object') {
                sendData = JSON.stringify(opt.jsonData);
            }
        } else if (opt.rawData) {
            sendData = opt.rawData;
        } else {
            xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=utf-8");
        }
    }
    if (opt.responseType == 'blob') {
        xhr.responseType = 'blob';
    }
    if (opt.headers) {
        for (var name in opt.headers) {
            xhr.setRequestHeader(name, opt.headers[name]);
        }
    }
    var token = Session.getToken();
    if (token && !opt.withCredentials) {
        if (!opt.headers || !opt.headers.Authorization) {
            xhr.setRequestHeader('Authorization', token);
        }
    } else {
        xhr.withCredentials = true;
    }

    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.send(sendData);
    if (opt.async) {
        xhr.onreadystatechange = function () {
            callback(xhr, resolve, reject, opt);
        }
    } else {
        callback(xhr, resolve, reject, opt);
    }
}

function ajax(opt) {
    opt = opt || {};
    opt.type = opt.type || opt.method || "GET";
    if (!urlRegexp.test(opt.url)) {
        opt.url = getBaseUrl() + (opt.url || "");
    }
    opt.async = type(opt.async) === 'undefined' ? true : opt.async;
    opt.data = opt.data || opt.params || null;

    if (opt.async) {
        return new Promise(function (resolve, reject) {
            request(opt, resolve, reject);
        });
    } else {
        // 同步方式下，直接通过传resolve函数来回调
        request(opt, opt.resolve, opt.reject);
    }
}

Vue.prototype.$ajax = ajax;

export default ajax;